'use client';
import cx from 'classnames';
import type React from 'react';
import styles from './styles.module.css';

interface ButtonProps {
  text?: string;
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  variant?: 'default' | 'outline' | 'ghost ' | 'link';
  color?: 'red' | 'gray' | 'light' | 'dark' | 'white' | 'transparent' | 'black';
  disabled?: boolean;
  size?: 'icnSm' | 'sm' | 'md' | 'lg';
  icon?: React.ReactNode;
  type?: 'button' | 'submit';
  iconPosition?: 'left' | 'right';
  isActive?: boolean;
  isLoading?: boolean;
  className?: string;
  ariaLabel?: string;
}

const Button: React.FC<ButtonProps> = ({
  text,
  variant = 'default',
  color = 'dark',
  disabled = false,
  icon,
  size = 'md',
  isActive = false,
  isLoading = false,
  type = 'button',
  onClick = () => {},
  className = '',
  iconPosition = 'left',
  ariaLabel,
}) => {
  const buttonClasses = cx(
    styles.button,
    styles[variant],
    styles[color],
    styles[size],
    {
      [styles.active]: isActive,
      [styles.loading]: isLoading,
    },
    className,
  );

  return (
    <button
      className={buttonClasses}
      disabled={disabled || isLoading}
      type={type}
      onClick={(event) => {
        if (type !== 'submit') {
          event.preventDefault();
          event.stopPropagation();
        }
        if (onClick) onClick();
      }}
      aria-label={ariaLabel}
    >
      {isLoading && <span className={styles.spinner} />}
      {!isLoading && icon && iconPosition === 'left' && (
        <span className={styles.iconLeft}>{icon}</span>
      )}
      {text && <span className={styles.text}>{text}</span>}
      {!isLoading && icon && iconPosition === 'right' && (
        <span className={styles.iconRight}>{icon}</span>
      )}
    </button>
  );
};

export default Button;
